// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/NotificationsPage/style.css
// module id = 1874
// module chunks = 0